import { Component, OnInit } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { AppSettings } from '../../app-settings';
import { HttpClientService } from '../../Services/http-client.service';


@Component({
  selector: 'user-info-header',
  templateUrl: './user-info-header.component.html',
  styleUrls: ['./user-info-header.component.css']
})
export class UserInfoHeaderComponent implements OnInit {
  
  menuSecIn:boolean= false;
  showExtensions: boolean = false;
  
  constructor(private httpClientService: HttpClientService) { }

  ngOnInit() {
    this.getData(); // Call your method on component init
  }
  hideSecHeader(event){
  	if(event.target != document.getElementById('my_info_btn_id') && event.target != document.getElementById('menu_sec_bot_icon_btn_id'))
  	{
  		this.menuSecIn = false;
  	}
  }

getData() {

    let headers = new HttpHeaders();
    this.httpClientService.get(AppSettings.restApiUrl + '/api/user/hasNonOfferPurchase', headers)
      .subscribe(
      (data) => {
        this.showExtensions = data;
      },
       (error) => {
        console.error('Error fetching trial status:', error);
        this.showExtensions = false;
      }
    );
}
}